import $http from "../../axios";
import { Notification } from "element-ui";

export async function getAccountsWithContactProviderFinancialInstitutionCategory({
    state,
    commit
}) {
    await $http
        .get("/api/incorporate-bank-statement/accounts")
        .then(response => {
            commit("setAccounts", response.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al traer la informacion.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            console.error(error);
        });
}

export async function importBankStatement({ state, commit }, confirmation) {
    const formData = new FormData();

    Object.entries(state.formBankStatement).forEach(([key, value]) => {
        formData.append(key, value);
    });

    if (confirmation) {
        formData.append("confirmation", confirmation);
    }

    commit("setFormBankStatementLoading", true);

    await $http
        .post("/api/incorporate-bank-statement/import", formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        })
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: response.data.message,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });

            commit("setFormBankStatement", {
                account_id: null,
                file: null
            });
            commit("setFormBankStatementLoading", false);
        })
        .catch(error => {
            commit("setFormBankStatementLoading", false);
            if (!error.response.data.data) {
                commit(
                    "setFormBankStatementResponse",
                    error.response ? error.response.data : "Error al importar"
                );
            } else {
                const csvContent = error.response.data.data
                    .map(row => row.join(";"))
                    .join("\n");

                const blob = new Blob([csvContent], {
                    type: "text/csv;charset=utf-8;"
                });
                const link = document.createElement("a");
                link.setAttribute("href", URL.createObjectURL(blob));
                link.setAttribute("download", "errores-extracto-bancario.csv");
                link.style.visibility = "hidden";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
}

export async function getBankConciliation({ state, commit }) {
    commit("setDataBankConciliationLoading", true);
    await $http
        .get("/api/incorporate-bank-statement/bank-conciliation", {
            params: state.formBankConciliation
        })
        .then(response => {
            commit("setDataBankConciliation", response.data.data);
            commit("setDataBankConciliationLoading", false);
            commit("setBankConciliationTransactionsDetail", false);
            commit(
                "setBankConciliationStatus",
                state.formBankConciliation.state
            );
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
            commit("setBankConciliationTransactionsDetail", false);
            commit("setBankConciliationStatus", null);

            Notification.error({
                title: "Error!",
                message: "Error al traer la informacion.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            console.error(error);
        });
}

export async function generateBankConciliation({ state, commit }) {
    commit("setDataBankConciliationLoading", true);
    await $http
        .post(
            "/api/incorporate-bank-statement/generate-bank-conciliation",
            state.formBankConciliation
        )
        .then(response => {
            commit("setGenerateBankConciliationResponse", response.data.data);
            commit("setDataBankConciliationLoading", false);
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
            Notification.error({
                title: "Error!",
                message: "Error al generar.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            // console.error(error);
        });
}

export async function saveBankConcilOperTransactions({
    state,
    commit,
    dispatch
}) {
    const {
        informationExtract,
        accountingInformation
    } = state.bankConciliationOperTransactions;

    const payload = {
        informationExtract: informationExtract.map(item => item.id),
        accountingInformation: accountingInformation.map(item => item.id)
    };

    commit("setDataBankConciliationLoading", true);

    await $http
        .post(
            "/api/incorporate-bank-statement/bank-conciliation-transactions",
            payload
        )
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: response.data.message,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });

            commit("setBankConciliationOperTransactions", {
                informationExtract: [],
                accountingInformation: []
            });
            commit("setDataBankConciliationLoading", false);
            dispatch("getBankConciliation");
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
        });
}

export async function getBankConcilOperTransactions({ state, commit }, data) {
    commit("setDataBankConciliationLoading", true);
    await $http
        .get(
            "/api/incorporate-bank-statement/get-bank-conciliation-transactions",
            {
                params: data
            }
        )
        .then(response => {
            commit("setDataBankConciliationTransactions", response.data.data);
            commit("setDataBankConciliationLoading", false);
            commit("setBankConciliationTransactionsDetail", true);
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
            commit("setBankConciliationTransactionsDetail", false);

            Notification.error({
                title: "Error!",
                message: "Error al traer la informacion.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            console.error(error);
        });
}

export async function deleteAllBankConcilOperTransactions(
    { state, commit, dispatch },
    all_delete = true
) {
    if (!all_delete) {
        let {
            informationExtract,
            accountingInformation
        } = state.bankConciliationOperTransactions;

        (state.formBankConciliation.informationExtract = informationExtract.map(
            item => item.id
        )),
            (state.formBankConciliation.accountingInformation = accountingInformation.map(
                item => item.id
            ));
    } else {
        state.formBankConciliation.informationExtract = null;
        state.formBankConciliation.accountingInformation = null;
    }
    commit("setDataBankConciliationLoading", true);
    await $http
        .delete(
            "/api/incorporate-bank-statement/delete-bank-conciliation-transactions",
            {
                params: state.formBankConciliation
            }
        )
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: response.data.message,
                type: "success",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("setDataBankConciliationLoading", false);
            dispatch("getBankConciliation");
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
        });
}

export async function validateDescriptionBankReconciliationReport({
    state,
    commit
}) {
    await $http
        .get(
            "/api/incorporate-bank-statement/validate-description-bank-reconciliation-report",
            {
                params: state.formBankConciliation
            }
        )
        .then(response => {
            commit("setBankReconciliationReport", {
                form: {
                    description: response.data.data.message
                }
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al traer la informacion.",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            console.error(error);
        });
}

export async function bankReconciliationReportPdf({ state, commit, dispatch }) {
    const payload = {
        observation: state.bankReconciliationReport.form.description || "",
        ...state.formBankConciliation
    };

    commit("setDataBankConciliationLoading", true);

    await $http
        .post(
            "/api/incorporate-bank-statement/bank-reconciliation-report",
            payload
        )
        .then(response => {
            commit("setBankReconciliationReportResponse", response.data.data);
            commit("setDataBankConciliationLoading", false);
        })
        .catch(error => {
            commit("setDataBankConciliationLoading", false);
        });
}

export async function getAuxAccounts({ state, commit }) {
    let params = {
        notAux: false,
        onlyAux: true,
        paginate: false
    };
    await $http
        .get("/api/cuentas", { params })
        .then(response => {
            commit("setAuxiliaryAccounts", response.data.data);
        })
        .catch(error => {});
}

export async function searchchconsecutive({ commit, state }, data) {
    await $http
        .get("/api/tipos-de-comprobantes/" + data.voucherType_id, {
            params: data
        })
        .then(response => {
            commit("setConsecutive", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}

export async function createVouchers({ commit, state }) {
    await $http
        .post("/api/comprobantes-varios", state.voucherPayload)
        .then(response => {
            state.voucherPayload.document_id = response.data.data.document.id;
            commit("updateVoucherPayload", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function finalizeAccountingDocument({ commit, state, dispatch }) {
    commit("setModalloading", true);
    await $http
        .post("/api/finalizar-documento-contable", state.voucherPayload)
        .then(response => {
            if (!response.data.status_concil) {
                Notification.error({
                    title: "Error!",
                    message: "Error al Crear la Conciliacion del Documento",
                    type: "error",
                    duration: 1500,
                    customClass: "notification-box"
                });
            }
            commit("setFinalizeVoucher", response.data.data);
            commit("setBankConciliationOperTransactions", {
                informationExtract: [],
                accountingInformation: []
            });
            commit("setModalloading", false);
        })
        .catch(error => {
            let data = error.response.data;
            Notification.error({
                title: "Error!",
                message: data.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}



// WEBPACK FOOTER //
// ./src/modules/incorporate-bank-statement/actions.js